/* lua.js generated code 0.3.0 */

PlayerHeadNodeProfile = xClass("PlayerHeadNodeProfile")
var HeadFrame = require("clover/panel/component/HeadFrame")
PlayerHeadNodeProfile.prototype.ctor = function (headUrl, name, score, rank, uid) {
    var self = this
    self.headUrl = headUrl
    self.name = name
    self.score = score
    self.rank = rank
    self.uid = uid
}
PlayerHeadNode = xClass("PlayerHeadNode", cc.Node)
PlayerHeadNode.fromFriend = 1
PlayerHeadNode.fromGlobal = 2
PlayerHeadNode.prototype.ctor = function (profile, user, from) {
    var self = this
    cc.Node.prototype.ctor.call(self)
    from = from || PlayerHeadNode.fromFriend
    self.profile = profile
    self.user = user
    self.isSelf = tostring(UserManager.getInstance().uid) === tostring(self.profile.uid)
    self.setPosition((self.profile.rank - 1) * PLAYER_HEAD_NODE_SIZE.width, 0)
    self.container = cc.Node.create()
    let dalte =  Math.max(30 - (from - 1) * 30, 0)
    // let dalte = 30
    self.container.setPosition(PLAYER_HEAD_NODE_SIZE.width / 2, PLAYER_HEAD_NODE_SIZE.height / 2 + dalte)
    self.addChild(self.container)
    var head = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_head.png")
    head.setPositionY(-7)
    head.nodeExist = true
    head.setScale(75 / head.getContentSize().width * 0.85)
    self.container.addChild(head, -9999, "user_head")
    HeadImageLoader.loadImage(head, self.profile.headUrl)
    self.container.setContentSize(head.getContentSize())
    var btn = UIGroupButton.create(self.container)
    btn.on(UIButtonEvent.Click, function () {
        var friendManager = FriendManager.getInstance()
        if (null == self.user) {
            if (!friendManager.isFriend(self.profile.uid) || null == friendManager.getFriendInfo(self.profile.uid)[0]) {
                return 
            }
        }
    })
    var bg = null
    var headFrameId
    if (self.isSelf) {
        headFrameId = UserManager.getInstance().getHeadFrameId()
    }else {
        headFrameId = (user && user.headFrameId) || 0
    }
    if (headFrameId > 0) {
        bg = HeadFrame.createHeadFrame(headFrameId, 0.7 * 0.85)
    } else {
        bg = cc.Sprite.createWithSpriteFrameName(self.isSelf && "uilibrary/tx02.png" || "uilibrary/tx01.png")
        if (self.profile.rank === 1) {
            var crown = cc.Sprite.createWithSpriteFrameName("uilibrary/crown.png")
            crown.setPosition(-25, 41)
            self.container.addChild(crown)
        }
    }
    self.container.addChild(bg)
    bg.setPositionY(-5)
    var rank = cc.Sprite.createWithSpriteFrameName((self.profile.rank > 3 || self.profile.rank < 1) && "uilibrary/nobg.png" || "uilibrary/no" + self.profile.rank + ".png")
    rank.setPosition(30, -32)
    self.container.addChild(rank)
    var colors = table(
        [0, cc.c3b(167, 117, 41)],
        [0, cc.c3b(100, 135, 132)],
        [0, cc.c3b(138, 73, 26)],
        [0, cc.c3b(65, 84, 46)]
    )
    var rankTex = cc.Label.createWithSystemFont(self.profile.rank, null, 18)
    rankTex.setColor((self.profile.rank > 3 || self.profile.rank < 1) && colors[4] || colors[self.profile.rank])
    rankTex.setPosition(15, 15)
    rank.addChild(rankTex)
    var name = cc.Label.createWithSystemFont(self.profile.name, null, 18)
    name.setAnchorPoint(0.5, 1)
    name.setPosition(PLAYER_HEAD_NODE_SIZE.width / 2, 62)
    self.addChild(name)
    UIUtils.fixTextWidthWithLabel(name, self.profile.name, 100)
    var score = cc.Label.createWithSystemFont(self.profile.score, null, 18)
    score.setAnchorPoint(0.5, 1)
    score.setPosition(PLAYER_HEAD_NODE_SIZE.width / 2, 38)
    self.addChild(score)
    if (from === PlayerHeadNode.fromGlobal) {
        name.setPositionY(name.getPositionY() - 30)
        score.setPositionY(score.getPositionY() - 30)
    }
}
var crown_poss = table(
    [0, table([0, -15 - 5], [0, 49 + 8])],
    [0, table([0, -15 - 3], [0, 49 + 5])],
    [0, table([0, -15], 49)]
)
var stars_poss = table(
    [0, table(
        [0, table([0, -8], 24)],
        [0, table([0, -40], [0, -20])],
        [0, table([0, -8], [0, -6])],
        [0, table(30, [0, -14])],
        [0, table([0, -8], 22)]
    )],
    [0, table(
        [0, table(4, 12)],
        [0, table([0, -3], [0, -22])],
        [0, table(6, [0, -10])],
        [0, table(17, 0)]
    )],
    [0, table(
        [0, table([0, -34], [0, -9])],
        [0, table(0, 12)],
        [0, table([0, -1], [0, -15])]
    )]
)
PlayerHeadNode.prototype.showCrown = function () {
    var self = this
    if (self.profile.rank >= 1 && self.profile.rank <= 3) {
        var pos = crown_poss[self.profile.rank]
        var crown = cc.Sprite.createWithSpriteFrameName("uilibrary/rankcrown" + self.profile.rank + ".png")
        crown.setPosition(pos[1], pos[2])
        self.container.addChild(crown)
        for (var k in stars_poss[self.profile.rank]) {
            var v = stars_poss[self.profile.rank][k]
            var random = math.random(1, 100) < 50
            var name = random && "cocos/uilibrary_rankcrown_anim1.csb" || "cocos/uilibrary_rankcrown_anim2.csb"
            var star = cc.CSLoader.createNode(name)
            star.setOpacity(math.random(120, 255))
            star.setScale((random && math.random(0.5, 0.8) || math.random(0.7, 1)) * (1 - (self.profile.rank - 1) / 10))
            var animation = cc.CSLoader.createTimeline(name)
            star.runAction(animation)
            animation.gotoFrameAndPlay(math.random(0, 15), false)
            animation.setLastFrameCallFunc(function () {
                animation.clearLastFrameCallFunc()
                animation.gotoFrameAndPlay(0, true)
            })
            star.setPosition(v[1] + pos[1], v[2] + pos[2])
            self.container.addChild(star)
        }
    }
}
/**
 * 容器对象池，防止排行榜拉太多了闪退
 */
PlayerScrollNodeContainerPool = {}
/**
 * 缓存池容量
 */
PlayerScrollNodeContainerPool._size_max = 30;
/**
 * 对象池对象列表
 */
PlayerScrollNodeContainerPool._pool = [];
/**
 * 对象池是否还存在对象
 */
PlayerScrollNodeContainerPool.HaveNode = function () {
    return this._pool.length > 0 ? true : false;
}
/**
 * 从对象池获取对象
 */
PlayerScrollNodeContainerPool.GetNode = function () {
    if (this.HaveNode()) {
        return this._pool.pop();
    } else {
        return null;
    }
}
/**
 * 向对象池放置对象
 */
PlayerScrollNodeContainerPool.Put = function (node) {
    if (this._pool.length >= this._size_max) {
        this.node.removeFromParent(true);
    } else {
        this._pool.push();
    }
}
PlayerScrollNode = xClass("PlayerScrollNode", cc.Node)
/**
 * 构造函数，只创建当前节点，暂不创建内容，防止加载太多内容后爆内存
 */
PlayerScrollNode.prototype.ctor = function (profile, offset, user) {
    cc.Node.prototype.ctor.call(this)
    var self = this
    self.profile = profile
    self.offset = offset || 0
    self.user = user
    self.isSelf = tostring(UserManager.getInstance().uid) === tostring(self.profile.uid)
    self.setCascadeOpacityEnabled(true)
}
/**
 * 如果对象池里没有对象了，则新创建节点容器
 */
PlayerScrollNode.prototype.createContainer = function () {
    var self = this
    self.container = cc.Node.create()
    self.container.setCascadeOpacityEnabled(true)
    self.container.setPosition(PLAYER_SCROLL_NODE_SIZE.width / 2, PLAYER_SCROLL_NODE_SIZE.height / 2)
    self.addChild(self.container)
    var line1 = ccui.Scale9Sprite.createWithSpriteFrameName(self.isSelf && "uilibrary/dark_blue_line_bg_1.png" || "uilibrary/blue_line_bg_1.png")
    line1.setAnchorPoint(cc.p(0, 0.5))
    line1.setContentSize(cc.size(616, 43.2))
    line1.setPosition(-255, 0)
    self.container.addChild(line1)
    self.headContainer = cc.Node.create()
    self.container.addChild(self.headContainer)
    self.bg = null
    self.headFrameId = self.isSelf && UserManager.getInstance().getHeadFrameId() || self.user.headFrameId
    if (self.headFrameId > 0) {
        self.bg = HeadFrame.createHeadFrame(self.headFrameId, 1, HeadFrame.Type_Small)
        HeadFrame.hiddenLevel(self.bg)
    } else {
        self.bg = cc.Sprite.createWithSpriteFrameName(self.isSelf && "uilibrary/tx02.png" || "uilibrary/tx01.png")
        self.bg.setScale(0.53)
    }
    self.bg.setPosition(145 - 255, 0)
    self.container.addChild(self.bg)
    self.rank = cc.Label.createWithSystemFont(self.profile.rank, null, 22)
    self.rank.setPosition(65 - 255, 0)
    self.container.addChild(self.rank)
    self.name = cc.Label.createWithSystemFont(self.profile.name, null, 22)
    self.name.setPosition(300 - 255, 0)
    self.container.addChild(self.name)
    UIUtils.fixTextWidthWithLabel(self.name, self.profile.name, 180)
    self.score = cc.Label.createWithSystemFont(self.profile.score, null, 22)
    self.score.setPosition(500 - 255, 0)
    self.container.addChild(self.score)
    self.headNode = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_head.png")
    self.headNode.nodeExist = true
    self.headNode.setScale(65 / self.headNode.getContentSize().width * 0.55)
    self.headNode.setPosition(145 - 255, 0)
    self.headContainer.addChild(self.headNode)
    //HeadImageLoader.loadImage(self.headNode, self.profile.headUrl)
}
PlayerScrollNode.prototype.onOptimize = function (visible) {
    var self = this
    self.setVisible(visible)

    if (visible) {
        if (!self.container) {
            self.updateData()
            HeadImageLoader.loadImage(self.headNode, self.profile.headUrl)
        }
    } else {
        PlayerScrollNodeContainerPool.Put(self.container)
        //self.headContainer.removeAllChildren(true)
    }
}
PlayerScrollNode.prototype.update = function (total) {
    var self = this
    total = Math.max(total, GLOBAL_SCROLL_COUNT + 3)
    self.setPosition(0, (total - self.profile.rank) * PLAYER_SCROLL_NODE_SIZE.height)
}
/**
 * 刷新节点数据，用于从对象池中获取后使用
 */
PlayerScrollNode.prototype.updateData = function () {
    var self = this

    if (PlayerScrollNodeContainerPool.HaveNode()) {
        //  从对象池创建
        self.container = PlayerScrollNodeContainerPool.GetNode()
        self.container.removeFromParent(false)
        self.addChild(self.container)

        self.headFrameId = self.isSelf && UserManager.getInstance().getHeadFrameId() || self.user.headFrameId
        self.bg.removeFromParent(true)
        if (self.headFrameId > 0) {
            self.bg = HeadFrame.createHeadFrame(self.headFrameId, 1, HeadFrame.Type_Small)
            HeadFrame.hiddenLevel(self.bg)
        } else {
            self.bg = cc.Sprite.createWithSpriteFrameName(self.isSelf && "uilibrary/tx02.png" || "uilibrary/tx01.png")
            self.bg.setScale(0.53)
        }
        self.bg.setPosition(145 - 255, 0)
        self.container.addChild(self.bg)
        self.rank.setString(self.profile.rank)
        self.name.setString(self.profile.name)
        UIUtils.fixTextWidthWithLabel(self.name, self.profile.name, 180)
        self.score.setString(self.profile.score)
    } else {
        //  新开内存创建
        self.createContainer()
    }
}
/**
 * 打开节点展示
 */
PlayerScrollNode.prototype.onOpen = function (posY, viewH) {
    var self = this
    var sposy = self.getPositionY()
    if (sposy > -posY + viewH || sposy < -posY + PLAYER_SCROLL_NODE_SIZE.height) {
        //self.container.setOpacity(255)
        //self.container.setScale(1)
        //self.container.setVisible(true)
        return 
    }
    if (!self.container) {
        self.updateData()
    }
    var time = Math.max((sposy + posY) * (0.3 / 240), 0) * 0.6
    self.container.setOpacity(0)
    self.container.setScale(0.05)
    self.container.setVisible(true)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(time))
    var act = table()
    table.insert(act, cc.FadeIn.create(0.1))
    table.insert(act, cc.ScaleTo.create(0.1, 1.1))
    table.insert(actionList, cc.Spawn.create(act))
    table.insert(actionList, cc.ScaleTo.create(0.05, 1))
    self.container.runAction(cc.Sequence.create(actionList))
}
/**
 * 关闭节点展示
 */
PlayerScrollNode.prototype.onClose = function (posY, viewH) {
    var self = this
    var sposy = self.getPositionY()
    if (sposy > -posY + viewH || sposy < -posY + PLAYER_SCROLL_NODE_SIZE.height || !self.container) {
        return 
    }
    var time = Math.max((-posY + viewH - sposy + 900) * (0.3 / 240), 0)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(time / 3))
    var act = table()
    table.insert(act, cc.FadeOut.create(0.1))
    table.insert(act, cc.ScaleTo.create(0.1, 0.35))
    table.insert(actionList, cc.Spawn.create(act))
    function call() {
        self.container.setOpacity(255)
        self.container.setScale(1)
        self.container.setVisible(false)
    }
    table.insert(actionList, cc.CallFunc.create(call))
    self.container.runAction(cc.Sequence.create(actionList))
}

HeadNode = xClass("HeadNode", cc.Node)
HeadNode.prototype.ctor = function (profile, needLabel = false) {
    let self = this
    cc.Node.prototype.ctor.call(self)
    self.profile = profile
    self.needLabel = needLabel
    self.initUI()
}
HeadNode.prototype.initUI = function () {
    let self = this
    let head = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_head.png")
    self.addChild(head, 0, "head")
    head.nodeExist = true
    HeadImageLoader.loadImage(head, self.profile.headUrl)

    // if (typeof self.profile.headFrameId !== "undefined") {
    //     self.headFrame = HeadFrame.createHeadFrame(self.profile.headFrameId)
    //     !self.profile.headFrameId && self.headFrame.setScale(1)
    //     let leves = self.headFrame.getChildByName("leves")
    //     !self.needLabel && leves && leves.setVisible(false)
    // }
    if (self.profile.headFrameType === 1) {
        self.headFrame = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_circle.png")
    }else if (self.profile.headFrameType === 2) {
        self.headFrame = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_circle2.png")
    }
    self.addChild(self.headFrame, 0, "headFrame")

    if (self.profile.hasDescText) {
        self.descText = cc.LabelBMFont.create("000", self.profile.textFont || "font/berlinsansfb_30_redstroke.fnt")
        self.descText.setAdditionalKerning(-2)
        // self.descText = ccui.TextBMFont.create("000", self.profile.textFont || "font/berlinsansfb_30_redstroke.fnt")
        // self.descText.getVirtualRenderer().setAdditionalKerning(-2)
        // self.descText.setScale(30/25)
        let bgNode = self.headFrame || self.head
        self.addChild(self.descText)
        let posY = -bgNode.getContentSize().height / 2 + self.descText.getContentSize().height * self.descText.getScale() / 2 * 0.5
        self.descText.y = posY
    }
    let size = self.headFrame.getContentSize()
    let scale = self.headFrame.getScale()
    self.setContentSize(size.width * scale, size.height * scale)
}
